module.exports = __webpack_public_path__ + "static/img/img-3.ccc8aaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew_/detail/jolin/1/img-3.jpg
// module id = cqmh
// module chunks = 1